<template>
  <button-custom :action="hide" padding="s">
    {{ $l.close }}
  </button-custom>
</template>

<script>
import ButtonCustom from '@/components/Button'
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    ButtonCustom
  },

  methods: {
    hide: function () {
      this.$store.dispatch('popupQuiz/hide', null)
    }
  }
}
</script>
